import { __assign, __awaiter, __extends, __generator, __rest } from "tslib";
import React from "react";
// import Vue from "vue";
import { doRequest } from "../request/request";
import { toQueryString } from "../utils/utils";
import { execFunction } from "../helpers/execFunction";
import { getLocation, parseQueryString } from "../utils/utils";
import { Observable } from "./observer";
import { queryAdvs, queryProducts } from "../service/material";
function debug() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.debug(args);
}
function uniqueArray(arr) {
    var result = [];
    arr.forEach(function (item) {
        if (result.indexOf(item) < 0) {
            result.push(item);
        }
    });
    return result;
}
var batchUpdateTask = [];
function runBatchUpdateTask() {
    var uniqueBatchUpdateTask = uniqueArray(batchUpdateTask);
    debug("批量执行更新组件的任务1", batchUpdateTask, "去重后的任务为", uniqueBatchUpdateTask);
    debug("批量执行更新组件的任务", batchUpdateTask, "去重后的任务为", uniqueBatchUpdateTask);
    uniqueBatchUpdateTask.forEach(function (task) {
        task();
    });
    batchUpdateTask.length = 0;
}
var generateReqId = (function () {
    var reqId = 0;
    return function () {
        return reqId++;
    };
})();
var sourceKey = 0;
//当前页面url变化肯定会重新加载，所以只执行一次
var normalQS = getLocation().split(/#!?/)[0];
var urlParamMap = parseQueryString(normalQS);
//url参数获取?a=b
function getUrlParam(name) {
    return urlParamMap[name];
}
//获取全局参数，常用获取后台直接注入到页面上的变量
function getGlobalParam(name) {
    //@ts-ignore
    return window[name];
}
//hash参数获取#/app?c=d
//由于hash变化不会导致重新加载，所以要重新加载
function getHashParam(name) {
    var _a = getLocation().split(/#!?/), hashQS = _a[1];
    var hashParamMap = parseQueryString(hashQS);
    return hashParamMap[name];
}
function getDynamicByType(name, scope) {
    switch (scope) {
        case "window":
            return getGlobalParam(name);
        case "hash":
            return getHashParam(name);
        case "url":
            return getUrlParam(name);
        case "page":
            //暂时用全局替代，后续会用页面变量处理
            return getGlobalParam(name);
        default:
            return "";
    }
}
//TODO 增加type==local的数据库也做filter处理
export var preProcessWidgetConfig = function (o, callFn, isReact) {
    if (isReact === void 0) { isReact = true; }
    var _dataUpdateFn = callFn._dataUpdateFn, _remoteCallFn = callFn._remoteCallFn, _hashCallFn = callFn._hashCallFn;
    for (var i in o) {
        var realValue = o[i];
        if (realValue) {
            var type = realValue.type, scope = realValue.scope;
            if (type === "jd") {
                var innerKey = "$$" + i + sourceKey++;
                if (isReact) {
                    var observalData = Observable(realValue, ["data"]);
                    observalData.observe("data", _dataUpdateFn);
                    o[i] = observalData.data;
                }
                _remoteCallFn && _remoteCallFn(innerKey, o[i]);
            }
            else if (type === "local") {
                var localFilter = realValue.localFilter;
                if (localFilter) {
                    try {
                        var filterFn = execFunction({
                            injectParam: "data",
                            functionBody: localFilter,
                        });
                        realValue.data = filterFn(realValue.data);
                    }
                    catch (e) {
                        console.warn("转化失败", e);
                    }
                }
            }
            else if (type === "remote") {
                var innerKey = "$$" + i + sourceKey++;
                var localFilter = realValue.localFilter;
                if (localFilter) {
                    try {
                        var filterFn = execFunction({
                            injectParam: "data",
                            functionBody: localFilter,
                        });
                        realValue.data = filterFn(realValue.data);
                    }
                    catch (e) {
                        console.warn("转化失败", e);
                    }
                }
                if (isReact) {
                    var observalData = Observable(realValue, ["data"]);
                    observalData.observe("data", _dataUpdateFn);
                    o[i] = observalData.data;
                }
                _remoteCallFn && _remoteCallFn(innerKey, o[i]);
            }
            else if (scope) {
                var name_1 = realValue.name;
                if (scope === "dynamic") {
                    var innerKey = "$$" + i + sourceKey++;
                    _remoteCallFn && _remoteCallFn(innerKey, realValue);
                }
                else if (scope !== "input" && scope !== "static") {
                    o[i] = getDynamicByType(name_1, scope);
                    if (scope === "hash") {
                        _hashCallFn && _hashCallFn(name_1);
                    }
                }
            }
            else if (typeof realValue === "object") {
                preProcessWidgetConfig(realValue, callFn, isReact);
            }
        }
    }
};
function hashChangeCompute() {
    var hashValMap = {};
    return function (hashMap) {
        var changeArr = [];
        Object.keys(hashMap).forEach(function (name) {
            var val = getHashParam(name);
            if (hashValMap[name] != val) {
                hashValMap[name] = val;
                changeArr.push(name);
            }
        });
        return changeArr;
    };
}
//通过分析依赖关系，确定最终发起的请求
function analysisDeps(reSendDataSource, hashRelatedDataSource) {
    var sendDataSourceObj = reSendDataSource.reduce(function (i, c) {
        i[c] = {
            del: false,
        };
        return i;
    }, {});
    for (var _i = 0, _a = Object.entries(sendDataSourceObj); _i < _a.length; _i++) {
        var _b = _a[_i], name_2 = _b[0], val = _b[1];
        var dataSourceInfo = hashRelatedDataSource.get(+name_2);
        var parentDataSourceId = dataSourceInfo.pid;
        if (sendDataSourceObj[parentDataSourceId]) {
            val.del = true;
        }
    }
    return Array.from(Object.entries(sendDataSourceObj), function (item) {
        var k = item[0], v = item[1];
        if (!v.del) {
            return k;
        }
    }).filter(Boolean);
}
function executeDataSource(pid, dataSourceMap, relateHashMap, that) {
    return __awaiter(this, void 0, void 0, function () {
        var uniqueRequest, reqTasks, advIds, goodsIds, _loop_1, _i, _a, _b, optionsStr, dataStubs;
        return __generator(this, function (_c) {
            uniqueRequest = {};
            reqTasks = [];
            advIds = [];
            goodsIds = [];
            dataSourceMap.forEach(function (val) {
                var config = val.config, advId = val.advId, goodsId = val.goodsId;
                if (config) {
                    var seq = JSON.stringify(config);
                    if (!uniqueRequest[seq]) {
                        uniqueRequest[seq] = [];
                    }
                    uniqueRequest[seq].push(val);
                }
                if (!!advId) {
                    advIds.push(advId.trim());
                }
                if (!!goodsId) {
                    goodsIds.push(goodsId.trim());
                }
            });
            if (advIds.length > 0) {
                reqTasks.push(queryAdvs({
                    ids: uniqueArray(advIds),
                }).then(function (res) {
                    if ((res === null || res === void 0 ? void 0 : res.subCode) === '0') {
                        if (that) {
                            that.setState({
                                apiError: "",
                            });
                        }
                        dataSourceMap.forEach(function (val) {
                            var advId = val.advId, count = val.count;
                            if (!!advId) {
                                val.data = res.advertGroup[advId.trim()].list.slice(0, count) || [];
                            }
                        });
                    }
                    else {
                        if (that) {
                            that.setState({
                                apiError: "组件数据异常，请检查配置",
                            });
                        }
                    }
                }));
            }
            if (goodsIds.length > 0) {
                reqTasks.push(queryProducts({
                    ids: uniqueArray(goodsIds),
                }).then(function (res) {
                    if ((res === null || res === void 0 ? void 0 : res.subCode) === '0') {
                        if (that) {
                            that.setState({
                                apiError: "",
                            });
                        }
                        dataSourceMap.forEach(function (val) {
                            var _a, _b;
                            var goodsId = val.goodsId, count = val.count;
                            if (!!goodsId) {
                                val.data = ((_b = (_a = res.productGroup[goodsId.trim()]) === null || _a === void 0 ? void 0 : _a.currentStage) === null || _b === void 0 ? void 0 : _b.productList.slice(0, count)) || [];
                            }
                        });
                    }
                    else {
                        if (that) {
                            that.setState({
                                apiError: "组件数据异常，请检查配置",
                            });
                        }
                    }
                }));
            }
            _loop_1 = function (optionsStr, dataStubs) {
                var id = generateReqId();
                var _d = JSON.parse(optionsStr), dataName = _d.dataName, extraConfig = __rest(_d, ["dataName"]);
                if (!dataName) {
                    return "continue";
                }
                var extra = extraConfig;
                if (window && window.dataSources) {
                    var dataSources = window.dataSources;
                    var dataSourceConfig = dataSources[dataName];
                    debug(dataName + "\u5B9E\u65F6\u914D\u7F6E\u4FE1\u606F" + JSON.stringify(dataSourceConfig));
                    if (dataSourceConfig) {
                        extra = __assign(__assign({}, extra), dataSourceConfig);
                    }
                }
                if (window && window.page_ctx && window.page_ctx.ds) {
                    var dataSourceDomains = window.page_ctx.ds;
                    var dataSourceDomain = dataSourceDomains[dataName];
                    debug(dataName + "\u5B9E\u65F6\u914D\u7F6E\u57DF\u540D" + dataSourceDomain);
                    if (dataSourceDomain) {
                        extra.url = "" + dataSourceDomain + extra.pathname;
                    }
                }
                var url = extra.url;
                var callFn = function (relateHashMap) {
                    return __awaiter(this, void 0, void 0, function () {
                        var options, subDataSources, _remoteCallFn;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    options = JSON.parse(JSON.stringify(extra));
                                    options.body = __assign(__assign({}, options.reqParams), options.dynamicParams);
                                    delete options.reqParams;
                                    delete options.dynamicParams;
                                    debug("\u53D1\u8D77\u8BF7\u6C42\u5E8F\u53F7\u4E3A" + id + ",url--" + url + " \u5173\u8054\u7684\u7236\u8BF7\u6C42" + pid + "\u7684\u8BF7\u6C42", options);
                                    subDataSources = new Map();
                                    _remoteCallFn = function (reqId, reqConfig) {
                                        subDataSources.set(reqId, reqConfig);
                                    };
                                    //首次运行时候会收集
                                    if (relateHashMap) {
                                        preProcessWidgetConfig(options, {
                                            _remoteCallFn: _remoteCallFn,
                                            _hashCallFn: function (name) {
                                                var v = relateHashMap[name];
                                                if (!v) {
                                                    relateHashMap[name] = [
                                                        {
                                                            id: id,
                                                            pid: pid,
                                                            callFn: callFn,
                                                        },
                                                    ];
                                                }
                                                if (v && v.findIndex(function (i) { return i.callFn === callFn; }) <= -1) {
                                                    v.push({
                                                        id: id,
                                                        pid: pid,
                                                        callFn: callFn,
                                                    });
                                                }
                                            },
                                        });
                                        debug("\u5206\u6790\u8BF7\u6C42" + id + "\u7684\u914D\u7F6E\u53C2\u6570,\u914D\u7F6E\u52A8\u6001\u6570\u636E\u6E90\u4E3A", subDataSources);
                                    }
                                    else {
                                        preProcessWidgetConfig(options, {
                                            _remoteCallFn: _remoteCallFn,
                                        });
                                    }
                                    if (!(subDataSources.size > 0)) return [3 /*break*/, 2];
                                    //请求存在下发接口的请求参数
                                    return [4 /*yield*/, executeDataSource(id, subDataSources, relateHashMap, that)];
                                case 1:
                                    //请求存在下发接口的请求参数
                                    _a.sent();
                                    _a.label = 2;
                                case 2: 
                                // 异常处理
                                return [2 /*return*/, requestForWidget(url, options)
                                        .then(function (respData) {
                                        var data = respData;
                                        dataStubs.forEach(function (stub) {
                                            var filter = stub.config.filter;
                                            var filterFn = null;
                                            if (filter) {
                                                filterFn = execFunction({
                                                    injectParam: "data",
                                                    functionBody: filter,
                                                });
                                            }
                                            if (filterFn) {
                                                try {
                                                    data = filterFn(respData);
                                                }
                                                catch (e) {
                                                    console.warn("转化失败", e);
                                                }
                                            }
                                            stub.data = data;
                                        });
                                    })
                                        .catch(function (e) {
                                        console.warn(e);
                                    })];
                            }
                        });
                    });
                };
                reqTasks.push(callFn(relateHashMap));
            };
            for (_i = 0, _a = Object.entries(uniqueRequest); _i < _a.length; _i++) {
                _b = _a[_i], optionsStr = _b[0], dataStubs = _b[1];
                _loop_1(optionsStr, dataStubs);
            }
            return [2 /*return*/, Promise.all(reqTasks)];
        });
    });
}
//仅支持简单的请求，暂不支持文件上传，下载
var requestForWidget = function (url, optionsParam) {
    var method = optionsParam.method, body = optionsParam.body, headers = optionsParam.headers, options = optionsParam.options;
    if (!body) {
        body = {};
    }
    for (var _i = 0, _a = Object.entries(body); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], val = _b[1];
        if (val) {
            var scope = val.scope;
            if (scope === "dynamic") {
                body[key] = val.data;
            }
            if (scope === "static" || scope === "input") {
                body[key] = val.value;
            }
        }
    }
    var extraOptions = {};
    if (headers) {
        extraOptions["headers"] = JSON.parse(headers);
    }
    if ((options &&
        options["Content-Type"] === "application/x-www-form-urlencoded") ||
        method === "GET" ||
        !method) {
        if (!method || method === "GET") {
            return doRequest(__assign(__assign({ url: url + toQueryString(body), method: method }, extraOptions), JSON.parse(options)));
        }
    }
    return doRequest(__assign(__assign(__assign(__assign({ url: url }, extraOptions), { method: method }), JSON.parse(options)), { data: body }));
};
export function fetchDataSource(dataSourceMap, isReact, that) {
    if (isReact === void 0) { isReact = true; }
    return __awaiter(this, void 0, void 0, function () {
        var relateHashMap, requestId, hashRelatedDataSource, hashCompute;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("advIds", dataSourceMap);
                    relateHashMap = {};
                    requestId = generateReqId();
                    return [4 /*yield*/, executeDataSource(generateReqId(), dataSourceMap, relateHashMap, that)];
                case 1:
                    _a.sent();
                    debug("\u5206\u6790\u5230requestId" + requestId + "\u5173\u8054\u7684hash\u4FE1\u606F\u4E3A", relateHashMap);
                    hashRelatedDataSource = new Map();
                    Object.entries(relateHashMap).map(function (item) {
                        var val = item[1];
                        val.forEach(function (element) {
                            var id = element.id;
                            hashRelatedDataSource.set(id, element);
                        });
                    });
                    debug("hash参数关联的数据源列表为", hashRelatedDataSource);
                    isReact && runBatchUpdateTask();
                    hashCompute = hashChangeCompute();
                    //初始化hash值
                    hashCompute(relateHashMap);
                    window.addEventListener("hashchange", function () {
                        return __awaiter(this, void 0, void 0, function () {
                            var changeHashNames, reSendDataSources, uniqueReSendDataSources, realSendDataSources, dd;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        changeHashNames = hashCompute(relateHashMap);
                                        debug("hash参数发生变化", changeHashNames);
                                        reSendDataSources = [];
                                        changeHashNames.forEach(function (id) {
                                            reSendDataSources.push.apply(reSendDataSources, relateHashMap[id].map(function (i) { return i.id; }));
                                        });
                                        uniqueReSendDataSources = Array.from(new Set(reSendDataSources));
                                        realSendDataSources = analysisDeps(uniqueReSendDataSources, hashRelatedDataSource);
                                        debug("hash参数发生变化", changeHashNames, "需要发起请求的数据源", realSendDataSources);
                                        dd = realSendDataSources
                                            .map(function (id) {
                                            var md = hashRelatedDataSource.get(+id);
                                            if (md) {
                                                return md.callFn();
                                            }
                                        })
                                            .filter(Boolean);
                                        return [4 /*yield*/, Promise.all(dd)];
                                    case 1:
                                        _a.sent();
                                        isReact && runBatchUpdateTask();
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }, false);
                    return [2 /*return*/];
            }
        });
    });
}
var EnhanceWidget = /** @class */ (function (_super) {
    __extends(EnhanceWidget, _super);
    function EnhanceWidget(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, config = _a.config, dataSourceMap = _a.dataSourceMap;
        var forceUpdate = _this.forceUpdate.bind(_this);
        _this.dataSourceMap = dataSourceMap ? dataSourceMap : new Map();
        preProcessWidgetConfig(config, {
            _remoteCallFn: function (reqId, reqConfig) {
                _this.dataSourceMap.set(reqId, reqConfig);
            },
            _dataUpdateFn: function () {
                batchUpdateTask.push(forceUpdate);
            },
        });
        _this.state = {
            error: null,
            apiError: null,
        };
        debug("分析组件配置中的动态数据源完成", _this.dataSourceMap);
        return _this;
    }
    EnhanceWidget.prototype.componentDidCatch = function (error) {
        if (error) {
            this.setState({
                error: error,
            });
        }
    };
    EnhanceWidget.prototype.render = function () {
        var _a = this.props, config = _a.config, Widget = _a.widget;
        var _b = this.state, error = _b.error, apiError = _b.apiError;
        debug("EnhanceWidget update1", config, Widget);
        return (React.createElement(React.Fragment, null, error ? (React.createElement("div", null, error.stack ? error.stack : error.message)) : apiError ? (React.createElement("div", { style: {
                width: "100%",
                height: "100%",
                fontSize: 36,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#666666",
                background: "#cccccc",
            } }, apiError)) : (React.createElement(Widget, __assign({}, config)))));
    };
    return EnhanceWidget;
}(React.PureComponent));
export { EnhanceWidget };
var RunningEnhanceWidget = /** @class */ (function (_super) {
    __extends(RunningEnhanceWidget, _super);
    function RunningEnhanceWidget(props) {
        return _super.call(this, props) || this;
    }
    RunningEnhanceWidget.prototype.componentDidMount = function () {
        fetchDataSource(this.dataSourceMap, true, this);
    };
    return RunningEnhanceWidget;
}(EnhanceWidget));
export { RunningEnhanceWidget };
export var EnhanceVueWidget = function () {
    //待优化
};
export var RunningEnhanceVueWidget = function () {
    //待优化
};
/* export const EnhanceVueWidget = (component: any, dataSourceMap?: any) => {
  return Vue.component<unknown, unknown, unknown, any>("enhanceVueWidget", {
    render(createElement) {
      return createElement(component, {
        props: {
          config: this.convertConfig,
        },
      });
    },
    data: function () {
      const convertConfig = JSON.parse(JSON.stringify(this.config));
      let _dataSourceMap: any = dataSourceMap;
      if (!_dataSourceMap) {
        _dataSourceMap = new Map();
      }
      preProcessWidgetConfig(convertConfig, {
        _remoteCallFn: (reqId: string, reqConfig: any) => {
          _dataSourceMap.set(reqId, reqConfig);
        },
      });
      debug("分析组件配置中的动态数据源完成", _dataSourceMap);
      return {
        convertConfig,
        dataSourceMap: _dataSourceMap,
      };
    },
    props: ["config"],
    mounted() {
      !dataSourceMap &&
        this.dataSourceMap.size > 0 &&
        //@ts-ignore
        fetchDataSource(this.dataSourceMap, false);
    },
  });
};
export const RunningEnhanceVueWidget = (component: any) => {
  return EnhanceVueWidget(component);
};*/
